// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"header_headerWrapper__MR3Rq","headerWrapper--scrolled":"header_headerWrapper--scrolled__GSrLz"};